/**
 * <OpenHours />
 *
 * The data i/o is in this format:
 * Mon/09:00-17:00;Wed/09:00-17:00;Thu/11:00-16:00;Fri/09:00-17:00;Sat/10:00-17:00;Sun/09:00-17:00;
 *
 * When it is closed, it is omitted (for eg. Tue is missing from the above)
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import TimeRange from 'components/UI/Form/Fields/TimeRange';  
import './OpenHours.scss';
import { TIME_FORMAT } from '../../constants'
import moment from 'moment';

const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const DEFAULT_VALUE = '';

const DEFAULT_TIME = '09:00-17:00';

export function openhours(props) {
  const {
    schema,
    onChange,
    options,
    placeholder,
    value,
  } = props;

  const {
    name,
  } = schema;

  const {
    maxlength,
  } = options;

  return (
    <OpenHours 
      name={name}
      value={value}
      onChange={onChange}
      {...options}
    />
  );
}

class OpenHours extends React.Component {
  constructor(props) {
    super(props);

    this.valueObj = {}
    this.onChangeTime = this.onChangeTime.bind(this);
    this.valueToStr = this.valueToStr.bind(this);
  }

  onChangeTime(day) {
    return ({ endMoment, startMoment })=>{
      this.valueObj[day] = {
        startMoment,
        endMoment,
      }
      this.props.onChange(this.valueToStr())
    }
  }

  onChangeClosed(day) {
    return (e)=>{
      this.valueObj[day].closed = e.target.checked;
      this.props.onChange(this.valueToStr());
    }
  }

  strToValue(strValue) {
    const dayParts = strValue.split(';');

    if (Array.isArray(dayParts) && dayParts.length > 0) {
      dayParts.forEach((part)=>{
        if (!part) {
          return;
        }
        const data = part.split('/');
        const day = data[0];
        const timeRange = data[1].split('-');

        this.valueObj[day] = {
          startMoment: moment(timeRange[0], TIME_FORMAT),
          endMoment: moment(timeRange[1], TIME_FORMAT),
        }
      })
    }

    WEEKDAYS.map((day)=>{
      if (!this.valueObj[day]) {
        this.valueObj[day] = {
          closed: true, 
        }
      }
    });
  }

  valueToStr() {
    let str = '';
    WEEKDAYS.map((day)=>{
      const dayData = this.valueObj[day];
      if (dayData.closed != true) {
        if (dayData.startMoment && dayData.endMoment) {
          const startTime = dayData.startMoment.format(TIME_FORMAT);
          const endTime = dayData.endMoment.format(TIME_FORMAT);
          str += `${day}/${startTime}-${endTime};`
        } else {
          str += `${day}/${DEFAULT_TIME};`
        }
      }
    });
    return str;
  }

  render() {
    const {
      name,
      value = DEFAULT_VALUE,
      onChange,
    } = this.props

    this.strToValue(value);

    const Items = WEEKDAYS.map((day, key)=>{
      const dayData = this.valueObj[day];
      return (<div className='openhours-day' key={key}>
          <div className='weekday'>
            <label>{__(day, 'weekdays')}</label>
          </div>
          <div className='time-range'>
            { dayData.closed != true &&
            <TimeRange 
              minuteStep={5} 
              startMoment={dayData.startMoment} 
              endMoment={dayData.endMoment} 
              onChange={this.onChangeTime(day)} />
            }
          </div>
          <div className='closed'>
            <label className='control'>
              <input 
                type='checkbox' 
                onChange={this.onChangeClosed(day)} 
                checked={dayData.closed}
              />{__('closed', 'openHours')}
              <span className='checkmark'></span>
            </label>
          </div>
        </div>);
    });

    return (
      <div className='openhours-wrapper form-input outline-form-field'>
        {Items}
      </div>
    ) 
  }
}

export default OpenHours;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/OpenHours/index.js